<template>
  <v-menu bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <ver-anexos :afastamento="atestado" v-if="isAtestEleicao() || !gerencial" />
      <movimentacao-atestado :movimentacao="atestado.movimentacao" />
      <cancelar-atestado :atestado="atestado" v-if="atestado.status < 3" />
    </v-list>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';
import CancelarAtestado from "./CancelarAtestado.vue";
import MovimentacaoAtestado from "./MovimentacaoAtestado.vue";
import VerAnexos from "./VerAnexos.vue";
export default {
  props: {
    atestado: Object,
  },
  computed: mapState("usuario",["gerencial"]),
  components: {
    MovimentacaoAtestado,
    CancelarAtestado,
    VerAnexos,
  },
  methods: {
    isAtestEleicao(){
      return this.atestado.codconfigatest == 7 && this.atestado.codconfigsituacao == 48
    }
  }
};
</script>

    